import React, { useEffect, useState } from 'react';
import { sbomApi } from './sbomApi';

/**
 * Delete a release from the Software BOM. The user types DELETE; the server checks it again,
 * with the `D` (Delete) letter on the release type. The Orcanos item itself is NOT deleted.
 */
export default function SbomDeleteModal({ release, onClose, onDeleted, onAuth }) {
  const [word, setWord] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const go = async () => {
    setBusy(true);
    setError('');
    try {
      await sbomApi.deleteRelease(release.item_id, word);
      onDeleted(release);
    } catch (e) {
      if (!onAuth(e)) setError(e.message);
      setBusy(false);
    }
  };

  return (
    <div className="sbom-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section className="sbom-modal" role="dialog" aria-modal="true" aria-labelledby="sbom-del-title">
        <div className="sbom-modal-head">
          <div>
            <h3 id="sbom-del-title">Delete {release.name}</h3>
            <div className="sbom-tiny sbom-muted">{release.components} components · {release.key}</div>
          </div>
          <button type="button" className="sbom-modal-x" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <div className="sbom-modal-body">
          <div>This removes the release from the Software BOM: its dependency tree and its earlier baselines.
            This cannot be undone.</div>
          <div className="sbom-error">The release and its components stay in Orcanos. To delete them there,
            open Orcanos and delete them yourself.</div>
          <label className="sbom-tiny">
            Type <b>DELETE</b> to confirm
            <input className="sbom-search" style={{ display: 'block', width: '100%', marginTop: 4 }} value={word}
              onChange={(e) => setWord(e.target.value)} autoFocus aria-label="Type DELETE to confirm"
              onKeyDown={(e) => { if (e.key === 'Enter' && word === 'DELETE' && !busy) go(); }} />
          </label>
          {error && <div className="sbom-error" role="alert">{error}</div>}
        </div>
        <div className="sbom-modal-foot">
          <button type="button" className="sbom-btn" onClick={onClose}>Cancel</button>
          <button type="button" className="sbom-btn sbom-btn--danger" onClick={go} disabled={busy || word !== 'DELETE'}>
            {busy ? 'Deleting…' : 'Delete release'}
          </button>
        </div>
      </section>
    </div>
  );
}
